/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export const getPageZoomLevel = (stores, pageIndex) =>
  stores.commonAppStore.getPageZoomLevel(pageIndex);

export const getNumPages = stores => stores.commonAppStore.getNumPages();

export const getPageTransformMatrix = (stores, pageIndex, options = {}) =>
  stores.commonAppStore.getPageTransformMatrix(pageIndex, options);

export const getViewRotationMatrix = (stores, pageIndex, rotationAngle) =>
  stores.commonAppStore.getViewRotationMatrix(pageIndex, rotationAngle);
